export default [
    {
        path: 'medidas/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'MedidasController' }
    },
    {
        path: 'medida/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'MedidasController' },
    },
    {
        path: 'medida/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'MedidasController'
        }
    },

    {
        path: 'relatorios/medidas',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/medidas/home',
        meta: { middleware: 'auth', controller: 'RelatorioMedidaController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_medidas',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioMedidaController' },
        }, {
            path: 'graficos',
            name: 'graficos_medidas',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioMedidaController' },
        }
        ]
    }
];


